<script>
import { MONTHS } from '@src/constants/date'
export default {
  props: {
    year: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      months: MONTHS,
      numberOfRows: 4,
      numberOfColumns: 3,
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    setMonth(index) {
      this.$emit('set-month', this.months[index].key)
    },
    getIndex(row, column) {
      return row * this.numberOfColumns + column
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-title class="primary--text justify-center">{{
      year ? year : 'Month Picker'
    }}</v-card-title>
    <v-card-text>
      <v-row
        v-for="(rowIndex, i) in numberOfRows"
        :key="'monthRowIndex-' + rowIndex"
      >
        <v-col
          v-for="(colIndex, j) in numberOfColumns"
          :key="'monthColIndex-' + colIndex"
        >
          <v-btn
            block
            text
            :max-width="mobile ? '20px' : '60px'"
            color="primary"
            @click="setMonth(getIndex(i, j))"
          >
            {{ months[getIndex(i, j)].short }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
</style>
